"use strict";

// import 'babel/polyfill';
var SG = window.SG || {}; // import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

window.SG = SG;

SG.init = function () {
  SG.ajaxCart();
  SG.events();
};

SG.events = function () {
  $("body").on("click", ".mobile-header .toggle-menu", function (event) {
    event.preventDefault();
    SG.toggleMobileSidebar();
  });
};

SG.init = function () {
  SG.ajaxCart();
  SG.events();

  if ($("body").attr("data-is-checkout")) {
    SG.checkout();
  }
};

SG.toggleMobileSidebar = function () {
  var $header = $(".mobile-header");
  var $topbarHeight = $(".TopbarContainer").height();
  if (SG.mobileSidebarVisible) {
    $("html").removeClass("mobile-menu-visible");

    SG.mobileSidebarVisible = false;

    document.body.classList.remove("lock--scroll");
    /*if (bodyScrollLock) {
      bodyScrollLock.enableBodyScroll($(".main-nav")[0]);
    } // */

  } else {
    // disableBodyScroll($(".main-nav")[0]);
    /*if (bodyScrollLock) {
      bodyScrollLock.disableBodyScroll($(".main-nav")[0]);
    }*/
    document.body.classList.add("lock--scroll");
    

    $("html").addClass("mobile-menu-visible");
    SG.mobileSidebarVisible = true;
    $("main .content").one("click", function (event) {
      event.preventDefault();
      SG.toggleMobileSidebar();
    });
  }
};

function debounce(func, wait) {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

var _syncCart = debounce(function(cart) {
  $(".cart-count").text(cart.item_count);
  $(".cart-total").text("$" + (cart.total_price / 100).toFixed(2));
  $("[data-cart-count]").attr("data-cart-count", cart.item_count);
  window.wwLayer.$store.commit("_cart/setCart",cart);
  window.UsefulApps._setCart(cart);
  if (window.ww_auto_open_cartdrawer === false) return;
  window.openCartDrawer();
}, 200);

SG.ajaxCart = function () {
  // Triggers whenever ajax cart request finishes
  $(document).on('cart.requestComplete', function (event, cart) {
    _syncCart(cart);
  }); // Update quantity via cart.js as it is changed

  $(".cart-row input.quantity").on("change keyup keydown", function (event) {
    var $input = $(event.currentTarget),
        $row = $input.closest(".cart-row"),
        itemID = $row.attr("data-cart-item-id"),
        value = parseInt($input.val(), 10);
    CartJS.updateItemById(itemID, value);
  }); // Handle product form submission

  $(".shopify-product-form").on("submit", function (event) {
    if (window.CartJS) {
      var $form = $(event.target),
          itemID = $form.find('#variant-selector-buttons input[name="id"]:checked').val(),
          $button = $form.find(".button.add"),
          originalButtonText = $button.text(),
          selling_plan = $form.find('[name="selling_plan"]').val();
      $button.text("Adding...");
      CartJS.addItem(itemID, 1, {
        "selling_plan": selling_plan
      }, {
        "success": function success(data, textStatus, jqXHR) {
          $button.text(originalButtonText);
        },
        "error": function error(jqXHR, textStatus, errorThrown) {
          $button.text(originalButtonText);
        }
      });
      event.preventDefault();
      return false;
    }
  });
  
  // Collection ATC
  $(".collection-item .add-btn").on("click", function (event) {
    if (window.CartJS) {
      console.log(event.target)
      var variantId = event.target.dataset.variantId,
          originalButtonText = event.target.innerText,
          selling_plan = event.target.dataset.sellingPlanId;
      event.target.innerText = "Adding ...";
      CartJS.addItem(variantId, 1, {
        "selling_plan": selling_plan
      }, {
        "success": function success(data, textStatus, jqXHR) {
          event.target.innerText = originalButtonText;
          // send to Klaviyo
          var _learnq = _learnq || [];
          var item = {
            Name: data.product_title,
            ProductID: data.product_id,
            Categories: [],
            ImageURL: data.image,
            URL: "https://strikegently.co"+data.url,
            Brand: data.vendor,
            Price: "$"+(data.discounted_price / 100).toFixed(2),
          };
          _learnq.push(['track', 'Added to Cart', item]);

        },
        "error": function error(jqXHR, textStatus, errorThrown) {
          event.target.innerText = originalButtonText;
        }
      });
    }
  });
};

SG.checkout = function () {
  var $upsellBlock = $("[data-upsell-product-id]");
  var upsellProductId = $upsellBlock && $upsellBlock.attr("data-upsell-product-id");

  if (upsellProductId) {
    jQuery.getJSON("/products/".concat(upsellProductId, ".js"), function (product) {
      console.log("product", product);

      if (product && product.available && !$(".product[data-product-id=".concat(product.id, "]")).length) {
        $(".checkout-upsell-image").attr("src", product.featured_image);
        $(".checkout-upsell-text-description").html(product.description);

        if (product.compare_at_price) {
          $(".checkout-upsell-compare-at-price").text((product.compare_at_price / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
          }));
        }

        $(".checkout-upsell-price").text((product.price / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        }));
        var addableVariant = product.variants ? product.variants[0].id : product.id;
        var $cta = $(".checkout-upsell-cta");
        $cta.on("click", function () {
          $cta.width($cta.width());
          $cta.text("Adding...");
          SG.addProductToCheckout(addableVariant);
        });
        $upsellBlock.removeClass("hidden");
      }
    });
  }
};

SG.addProductToCheckout = function (productId) {
  var data = {
    'items': [{
      'id': productId,
      'quantity': 1
    }]
  };
  $.ajax("/cart/add.js", {
    data: JSON.stringify(data),
    contentType: 'application/json',
    type: 'POST'
  }).always(function () {
    setTimeout(function () {
      location.reload();
    }, 500);
  });
};

$(document).ready(function () {
  SG.init();
});